import i18n from '@/plugins/i18n'

export const hasTypeInfo = {
  loaderInfo: 'loader-info',
  truckerInfo: 'trucker-info',
}

export const smsSentReport = [
  { name: 'Date & Time', value: 'date' },
  { name: 'Mobile No.', value: 'mobile' },
  { name: 'Template ID', value: 'template_id' },
  { name: 'Template', value: 'template' },
  { name: 'SMS Status', value: 'status' },
]

export const confirmationType = {
  pending: 'Pending',
  booked: 'Booked',
  Booked: 'Confirmed',
  confirmed: 'Confirmed',
  cancelled: 'Cancelled',
  completed: 'Completed',
}

export const confirmationListKeys: Record<string, any> = {
  loadingPoints: 'loadingPoints',
  unloadingPoints: 'unloadingPoints',
  materials: 'materials',
  conditions: 'conditions',
  preferredRoutes: 'preferredRoutes',
  confirmation: 'confirmation',
  page: 'page',
  limit: 'limit',
  totalFreight: i18n.global.t('Total Freight'),
  freight: i18n.global.t('Freight'),
  crossing: i18n.global.t('Crossing'),
  freightMethod: i18n.global.t('Freight Method'),
  quantity: i18n.global.t('Quantity'),
  commission: i18n.global.t('Commission'),
  totalAmount: i18n.global.t('Total Amount'),
  balanceAmountTitle: i18n.global.t('Balance Amount'),
  document: {
    directory: 'ConfirmationDocuments',
    section: 'confirmation_documents',
    podSection: 'pod_documents',
  },
  NA: i18n.global.t('N/A'),
  booked: 'Booked',
  sms: 'sms',
  whatsapp: 'whatsapp',
  noPaymentLink: 'Your account with this user is now fully settled. There is no outstanding balance.',
  preferredContact: 'preferredContact',
  altContactMobile: 'altContactMobile',
  ownerContact: 'ownerContact',
  driverMobile: 'driverMobile',
  notes: 'notes',
  freight_amount: i18n.global.t('Freight'),
  truck_freight: 'Truck Freight',
  pr_amount: i18n.global.t('PR'),
  or_amount: i18n.global.t('OR'),
  freightAmount: 'freightAmount',
  balanceAmount: 'balanceAmount',
  pending: 'Pending',
  businessName: 'businessName',
  misc: 'Misc',
  additionalCharges: i18n.global.t('Additional Charges'),
  maxAmount: 10000000000,
  askStatus: 'The current status of the Confirmation is "Pending". Would you like to change it to "Confirmed"?',
  lessAmountPaymentLink: 'The receiving amount is less than ₹ 100.00, so payment link can\'t be generated.',
}

export const confirmationTableOptions = reactive({
  page: 1,
  limit: 10,
  hybridUserType: null,
})

export const confirmationStatus = {
  Pending: 'Pending',
  Booked: 'Confirmed',
  Cancelled: 'Cancelled',
  Completed: 'Completed',
  Confirmed: 'Confirmed',
}

export const confirmationSearchStatus = [
  { text: 'Confirmed', value: 'Confirmed' },
  { text: 'Pending', value: 'Pending' },
  { text: 'Completed', value: 'Completed' },
  { text: 'Cancelled', value: 'Cancelled' },
  { text: 'All', value: '' },
]

export const podSearchStatus = [
  { text: 'Confirmed', value: 'Confirmed' },
  { text: 'Completed', value: 'Completed' },
  { text: 'All', value: '' },
]

export const confirmationSaveType = {
  freight: 'freight',
  pod: 'pod',
  crossing: 'crossing',
  update: 'update',
}

export const paymentMethod = {
  cash: 'CASH',
  netBanking: 'NETBANKING',
  razorpay: 'RAZORPAY',
  mcBook: 'MC_BOOK',
}

// Per-section wiring for entries added from a confirmation's standing instructions.
// Each section settles against its own balance and posts to its own endpoint, so the
// dialog is told which one it is rather than inferring it.
export const confirmationEntrySections: Record<string, {

  /**
   * Omitted for sections that can settle in either direction (Other Charges) — the
   * dialog derives Received/Paid from the sign of sectionBalance instead.
   */
  ledgerType?: string
  addTitleKey: string
  editTitleKey: string

  /** Only set for sections that post to the freight/POD entry endpoint */
  amountType?: string
}> = {
  crossingCommission: {
    ledgerType: 'Received',
    addTitleKey: 'confirmation.add_crossing_commission_entry',
    editTitleKey: 'confirmation.edit_crossing_commission_entry',
  },
  freightLoader: {
    ledgerType: 'Received',
    addTitleKey: 'confirmation.add_freight_entry',
    editTitleKey: 'confirmation.edit_freight_entry',
    amountType: 'FREIGHT',
  },
  podLoader: {
    ledgerType: 'Received',
    addTitleKey: 'confirmation.add_pod_entry',
    editTitleKey: 'confirmation.edit_pod_entry',
    amountType: 'POD',
  },
  freightTrucker: {
    ledgerType: 'Paid',
    addTitleKey: 'confirmation.add_freight_trucker_entry',
    editTitleKey: 'confirmation.edit_freight_trucker_entry',
    amountType: 'FREIGHT',
  },
  podTrucker: {
    ledgerType: 'Paid',
    addTitleKey: 'confirmation.add_pod_trucker_entry',
    editTitleKey: 'confirmation.edit_pod_trucker_entry',
    amountType: 'POD',
  },
  toPayLoader: {
    ledgerType: 'Received',
    addTitleKey: 'confirmation.add_topay_entry',
    editTitleKey: 'confirmation.edit_topay_entry',
    amountType: 'TOPAY',
  },
  toPayTrucker: {
    ledgerType: 'Paid',
    addTitleKey: 'confirmation.add_topay_trucker_entry',
    editTitleKey: 'confirmation.edit_topay_trucker_entry',
    amountType: 'TOPAY',
  },
  otherChargesLoader: {
    addTitleKey: 'confirmation.add_received_paid_entry',
    editTitleKey: 'confirmation.edit_received_paid_entry',
    amountType: 'OTHER_CHARGES',
  },
  otherChargesTrucker: {
    addTitleKey: 'confirmation.add_received_paid_entry',
    editTitleKey: 'confirmation.edit_received_paid_entry',
    amountType: 'OTHER_CHARGES',
  },
}

export const paymentType = {
  cash: 'Cash',
  netBanking: 'Net Banking',
  mcBook: 'MC Books',
}

export const documentsTypesOptions = reactive({
  page: 1,
  results: 10,
  sortField: null,
  sortOrder: null,
  search: true,
  type: '',
})

export const getModuleTitle = [
  { title: 'Loader' },
  { title: 'Trucker' },
  { title: 'Driver' },
]

export const getLoadingTitle = [
  { title: 'Loading Point', value: 'loadingPointMessage' },
]

export const getUnloadingTitle = [
  { title: 'Unloading Point' },
]

export const userType = [
  { text: i18n.global.t('loader.type'), value: 'loader' },
  { text: i18n.global.t('trucker.type'), value: 'trucker' },
  { text: i18n.global.t('Hybrid User'), value: 'hybrid' },
]

export const confirmationsSearchFields = reactive({
  confirmationId: '',
  confirmationDate: '',
  loadId: '',
  loaderId: '',
  hybridUserId: '',
  loaderBusinessName: '',
  offerBusinessName: '',
  loaderTradingName: '',
  offerTradingName: '',
  loaderPrimaryName: '',
  loaderPrimaryNo: '',
  loaderAltName: '',
  loaderAltNo: '',
  loadingPoints: null,
  unloadingPoints: null,
  loadingCluster: null,
  capacity: null,
  industry: null,
  products: null,
  offerOwnerPrimaryName: '',
  offerPlaceName: null,
  offerCluster: null,
  offerOwnerPrimaryNo: '',
  driverName: '',
  driverNo: '',
  truckNo: '',
  tyres: null,
  freightMethod: null,
  remark: null,
  status: null,
  offerId: '',
  truckerId: '',
  targetedRouteId: '',
  isDue: null,
  combinedLoaderId: '',
  combinedTruckerId: '',
})

export const resetConfirmationsSearchFields = ({ ...confirmationsSearchFields })

export const podSearchFields = reactive({
  confirmationId: '',
  confirmationDate: '',
  loadId: '',
  loaderId: '',
  loaderBusinessName: '',
  offerBusinessName: '',
  loaderTradingName: '',
  offerTradingName: '',
  loaderPrimaryName: '',
  loaderPrimaryNo: '',
  loaderAltName: '',
  loaderAltNo: '',
  loadingPoints: null,
  unloadingPoints: null,
  loadingCluster: null,
  capacity: null,
  industry: null,
  products: null,
  offerOwnerPrimaryName: '',
  offerPlaceName: null,
  offerCluster: null,
  offerOwnerPrimaryNo: '',
  driverName: '',
  driverNo: '',
  truckNo: '',
  tyres: null,
  freightMethod: null,
  remark: null,
  status: null,
  offerId: '',
  truckerId: '',
  isDue: null,
  hybridUserId: '',
})

export const resetPodSearchFields = ({ ...podSearchFields })

export const SMS_TYPE = {
  CONFIRMATION_LINK: 'confirmationLink',
  BANK_DETAILS: 'bankDetails',
  PAYMENT_LINK: 'paymentLink',
  PROFILE_PAYMENT_LINK: 'profilePaymentLink',
}

export const invoiceListHeader = [
  { title: 'Invoice No.', key: 'invoiceNo', sortable: false, width: '5%' },
  { title: 'Document Type', key: 'invoiceType', sortable: false, width: '15%' },
  { title: 'Loading Point', key: 'loadingPoint', sortable: false, width: '15%' },
  { title: 'Unloading Point', key: 'unLoadingPoint', sortable: false, width: '10%' },
  { title: 'Materials/Products', key: 'material', sortable: false, width: '10%' },
  { title: 'Capacity', key: 'capacity', sortable: false, width: '10%' },
  { title: 'Freight', key: 'totalFreight', sortable: false, width: '10%' },
  { title: 'Date', key: 'invoiceDate', sortable: false, width: '10%' },
  { title: 'Actions', key: 'actions', sortable: false, width: '5%' },
]

export const dueValues = [
  { text: i18n.global.t('Due'), value: 'true' },
  { text: i18n.global.t('No Due'), value: 'false' },
]

export const commissionTableFields = [
  {
    title: 'ID',
    key: 'id',
    sortable: false,
  },
  {
    title: 'Mode',
    key: 'paymentMethod',
    sortable: false,
  },
  {
    title: 'Received',
    key: 'amount',
    sortable: false,
  },
  {
    title: 'Discount',
    key: 'discount',
    sortable: false,
  },
  {
    title: 'Balance',
    key: 'balance',
    sortable: false,
  },
  {
    title: 'Updated Timestamp',
    key: 'updatedAt',
    sortable: false,
  },
  {
    title: 'Actions',
    key: 'actions',
    sortable: false,
    align: 'center',
  },
]

export const confirmationStatusOptions = [
  {
    text: 'Confirmed',
    value: 'Booked',
  },
  {
    text: 'Pending',
    value: 'Pending',
  },
]

export const confirmationDetailsColumns = [
  {
    title: 'Loading Date',
    key: 'confirmedAt',
  },
  {
    title: 'Status',
    key: 'status',
  },
  {
    title: 'Notes',
    key: 'notes',
  },
  {
    title: 'Conditions',
    key: 'conditions',
  },
  {
    title: '',
    key: '',
  },
  {
    title: '',
    key: '',
  },
]

export const stateOptions = [
  { name: 'Andaman & Nicobar', value: 'Andaman & Nicobar' },
  { name: 'Andhra Pradesh', value: 'Andhra Pradesh' },
  { name: 'Arunachal Pradesh', value: 'Arunachal Pradesh' },
  { name: 'Assam', value: 'Assam' },
  { name: 'Bihar', value: 'Bihar' },
  { name: 'Chandigarh', value: 'Chandigarh' },
  { name: 'Chhattisgarh', value: 'Chhattisgarh' },
  { name: 'Dadra & Nagar Haveli', value: 'Dadra & Nagar Haveli' },
  { name: 'Daman and Diu', value: 'Daman and Diu' },
  { name: 'Delhi', value: 'Delhi' },
  { name: 'Goa', value: 'Goa' },
  { name: 'Gujarat', value: 'Gujarat' },
  { name: 'Haryana', value: 'Haryana' },
  { name: 'Himachal Pradesh', value: 'Himachal Pradesh' },
  { name: 'Jammu & Kashmir', value: 'Jammu & Kashmir' },
  { name: 'Jharkhand', value: 'Jharkhand' },
  { name: 'Karnataka', value: 'Karnataka' },
  { name: 'Kerala', value: 'Kerala' },
  { name: 'Lakshadweep', value: 'Lakshadweep' },
  { name: 'Madhya Pradesh', value: 'Madhya Pradesh' },
  { name: 'Maharashtra', value: 'Maharashtra' },
  { name: 'Manipur', value: 'Manipur' },
  { name: 'Meghalaya', value: 'Meghalaya' },
  { name: 'Mizoram', value: 'Mizoram' },
  { name: 'Nagaland', value: 'Nagaland' },
  { name: 'Odisha', value: 'Odisha' },
  { name: 'Puducherry', value: 'Puducherry' },
  { name: 'Punjab', value: 'Punjab' },
  { name: 'Rajasthan', value: 'Rajasthan' },
  { name: 'Sikkim', value: 'Sikkim' },
  { name: 'Tamil Nadu', value: 'Tamil Nadu' },
  { name: 'Telangana', value: 'Telangana' },
  { name: 'Tripura', value: 'Tripura' },
  { name: 'Uttar Pradesh', value: 'Uttar Pradesh' },
  { name: 'Uttarakhand', value: 'Uttarakhand' },
  { name: 'West Bengal', value: 'West Bengal' },
]
export const transactionDocumentTypes = {
  employee: 'employee',
  loadingPoint: 'loading_point',
  unloadingPoint: 'unloading_point',
  driver: 'driver',
  truck: 'truck',
}

export const confirmationStatusOptionsCompleted = [
  {
    text: 'Confirmed',
    value: 'Booked',
  },
  {
    text: 'Pending',
    value: 'Pending',
  },
  {
    text: 'Completed',
    value: 'Completed',
  },
  {
    text: 'Cancelled',
    value: 'Cancelled',
  },
]

// Money columns compare numerically with blank as 0 — Vuetify's default sort skips null
// values, which leaves those rows in an unstable order.
const sortAsNumber = (a: any, b: any) => (Number(a) || 0) - (Number(b) || 0)

export const ledgerEntryTableFields = [
  {
    title: 'ID',
    key: 'formattedId',
    sortable: true,
  },
  {
    title: 'Date',
    key: 'date',
    sortable: true,
  },
  {
    title: 'CNF ID',
    key: 'confirmationId',
    sortable: true,
  },
  {
    title: 'Description',
    key: 'description',
    sortable: true,
  },
  {
    title: 'Amount Type',
    key: 'amountType',
    sortable: true,
  },
  {
    title: 'Tran. Type',
    key: 'paymentMethod',
    sortable: true,
  },
  {
    title: 'Remarks',
    key: 'reference',
    sortable: true,
  },
  {
    title: 'Receivable',
    key: 'receivable',
    sortable: true,
    sort: sortAsNumber,
  },
  {
    title: 'Received',
    key: 'received',
    sortable: true,
    sort: sortAsNumber,
  },
  {
    title: 'Payable',
    key: 'payable',
    sortable: true,
    sort: sortAsNumber,
  },
  {
    title: 'Paid',
    key: 'paid',
    sortable: true,
    sort: sortAsNumber,
  },
  {
    title: 'Discount',
    key: 'discount',
    sortable: true,
    sort: sortAsNumber,
  },
  {
    title: 'Actions',
    key: 'actions',
    sortable: false,
    align: 'start',
  },
]

export const truckerCommissionTableFields = [
  {
    title: 'ID',
    key: 'id',
    sortable: false,
  },
  {
    title: 'Mode',
    key: 'paymentMethod',
    sortable: false,
  },
  {
    title: 'Paid',
    key: 'amount',
    sortable: false,
  },
  {
    title: 'Discount',
    key: 'discount',
    sortable: false,
  },
  {
    title: 'Balance',
    key: 'balance',
    sortable: false,
  },
  {
    title: 'Updated Timestamp',
    key: 'updatedAt',
    sortable: false,
  },
]
